import { ISubAccountData } from "@/store/SubAccountStore";
import { TextButton } from "@/pages/child-customer/atom";
import { Fragment, useState } from "react";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Modal } from "@/components/renderbus-modal";
import { UnregisterModalStyle } from "./atom";
import WarnningIcon from "@/pages/child-customer/icons/warning";
import styled from "styled-components";
import { Checkbox } from "@renderbus/ui";
import request from "project-config/services/request/request";
import { message } from "antd";
import { useSubAccountStore } from "@/store/SubAccountStore";
import { useGlobalStore } from "@/store/GlobalStore";
import { useTranslation } from "react-i18next";

export function UnregisterButton({
  onClick,
  isDingTalk,
}: {
  onClick: () => void;
  isDingTalk?: boolean;
}) {
  const t = getTranslateNsT("center");
  return (
    <Fragment>
      <TextButton type="text" onClick={onClick}>
        {t(
          isDingTalk
            ? "analysis_table_opertate_delete"
            : "user_com_childManage_del_render_btn_del"
        )}
      </TextButton>
    </Fragment>
  );
}

export function UnregisterModal({
  open,
  setOpen,
  isDingTalkSubAccount,
  ...row
}: ISubAccountData & {
  open: boolean;
  setOpen: (open: boolean) => void;
  isDingTalkSubAccount?: boolean;
}) {
  const t = getTranslateNsT("center");
  const { t: centerT } = useTranslation("center");
  const [check, setCheck] = useState(true);
  const { fetchSubAccountList, fetchDingTalkSubAccountList, isSearchSubUser } =
    useSubAccountStore();
  const { currencySymbol, isDomestic } = useGlobalStore();
  async function handleSubmit() {
    const res = await request.post(
      row?.isDingTalk
        ? "/api/rendering/user/deleteDingTalkSubUserStatus"
        : "/api/rendering/user/deleteSubUser",
      {
        id: row.id,
        clearPhoneEmail: row?.isDingTalk ? undefined : Number(check),
      }
    );
    setOpen(false);
    setCheck(true);
    if (res.code === 200) {
      if (row?.isDingTalk) {
        fetchDingTalkSubAccountList({
          deptId: row.deptId,
          subUserId: isSearchSubUser ? row.id : undefined,
        });
      } else {
        fetchSubAccountList();
      }
      message.success(
        t(
          row?.isDingTalk
            ? "user_deleted_success"
            : "user_com_childManage_msg_del_success"
        )
      );
    }
    if (res.code === 612) {
      message.warning(
        t(
          row?.isDingTalk
            ? "user_dingtalk_delete_message_612"
            : "user_delete_message_612"
        )
      );
    }
    if (res.code === 913) {
      const { rmbBalance, usdBalance } = row;
      const msg = `${currencySymbol}${Math.abs(
        isDomestic ? rmbBalance : usdBalance
      )}`;
      message.warning(
        centerT(
          row?.isDingTalk
            ? "user_dingtalk_delete_message_713"
            : "user_delete_message_713",
          { msg }
        )
      );
    }
    if (res.code === 715) {
      message.warning(
        t(
          row?.isDingTalk
            ? "user_dingtalk_delete_message_715"
            : "user_delete_message_715"
        )
      );
    }
    if (res.code === 714 || res.code === 716) {
      message.warning(
        t(
          row?.isDingTalk
            ? "user_dingtalk_delete_message_7"
            : "user_delete_message_7"
        )
      );
    }
    if (res.code === 914) {
      message.warning(
        t(
          row?.isDingTalk
            ? "del_dingtalk_subuser_exists_balance"
            : "delsubuser_exists_balance"
        )
      );
    }
    if (res.code === 800) {
      message.warning(t("user_delete_message_800"));
    }
  }
  return (
    <>
      <Modal
        open={open}
        className={"unregister-modal"}
        title={
          <TitleWrapper>
            <WarnningIcon />
            <Tilte>
              {t(
                row?.isDingTalk
                  ? "dingtalk_subaccount_user_delete_tip"
                  : "user_com_childManage_del_title"
              )}
            </Tilte>
          </TitleWrapper>
        }
        children={
          <Wrapper isDingTalk={row?.isDingTalk}>
            <span>
              {t(
                row?.isDingTalk
                  ? "dingtalk_subaccount_user_delete_helptip"
                  : "user_com_childManage_del_tip"
              )}
            </span>
            {!row?.isDingTalk && (
              <Checkbox
                onChange={(e) => setCheck(e.target.checked)}
                checked={check}
              >
                {t("user_Com_childManage_del_checkbox")}
              </Checkbox>
            )}
          </Wrapper>
        }
        onCancel={() => {
          setOpen(false);
          setCheck(true);
        }}
        onOk={handleSubmit}
      />
      <UnregisterModalStyle />
    </>
  );
}

const Wrapper = styled.div<{ isDingTalk?: boolean }>`
  display: flex;
  flex-direction: column;
  > span {
    padding-top: 20px;
    font-size: 14px;
    color: #bfc2c3;
    text-align: ${({ isDingTalk }) => (isDingTalk ? "center" : "left")};
  }
  > label {
    margin-top: 24px;
    color: #bfc2c3;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Tilte = styled.div`
  margin-left: 9px;
  font-size: 16px;
  color: #d9dfe0;
`;
